import styled, { css } from 'styled-components';
import { HTMLProps } from 'react';

interface IContainerProps extends HTMLProps<HTMLDivElement> {
    isAssuming: boolean;
}

export const HelperContainer = styled.div`
    display: flex;
    align-items: center;
    margin-left: auto;
    margin-right: 2rem;
    justify-content: center;
`;

export const Container = styled.div<IContainerProps>`
    ${({ isAssuming }) => css`
        display: flex;
        align-items: center;
        visibility: ${isAssuming ? 'visible' : 'hidden'};
        button {
            animation: flashing 1.5s linear infinite;
        }
        button:hover {
            animation: none;
        }

        @keyframes flashing {
            50% {
                opacity: 0.3;
            }
        }
    `}
`;
